<template>
  <div id="modals-container">
    <modal
      v-for="modal in modals"
      :key="modal.id"
      v-bind="modal.modalAttrs"
      v-on="modal.modalListeners"
      @closed="remove(modal.id)"
      :ref="modal.id"
    >
      <component
        :is="modal.component"
        v-bind="modal.componentAttrs"
        v-on="$listeners"
        @close="close(modal, $event)"
        @dismiss="dismiss(modal, $event)"
      />
    </modal>
  </div>
</template>
<script>
import { generateId } from '../utils'

const PREFIX = 'dynamic_modal_'

export default {
  data() {
    return {
      modals: []
    }
  },
  created() {
    /**
     * Register ModalContainer so that it was availiable inside the plugin
     */
    this.$root.__modalContainer = this
  },
  mounted() {
    this.$modal.subscription.$on('hide-all', () => {
      this.modals = []
    })
  },
  methods: {
    add({component, componentAttrs = {}, modalAttrs = {}, modalListeners = {}, showPromise, resultPromise}) {
      const id = generateId()
      const name = modalAttrs.name || PREFIX + id
      const modal = {
        id,
        modalAttrs: { ...modalAttrs, name },
        modalListeners,
        component,
        componentAttrs,
        showPromise,
        resultPromise
      }
      this.modals.push(modal)

      this.$nextTick(() => {
        modal.instance = this.$refs[id][0]
        this.$modal.show(name)
        showPromise.resolve(modal.instance)
      })
    },
    close(modal, $event) {
      this.$modal.hide(modal.modalAttrs.name, $event)
      try {
        modal.resultPromise.resolve( $event )
      } catch (e) {}  
    },
    dismiss(modal, $event) {
      this.$modal.hide(modal.modalAttrs.name, $event)
      try {
        modal.resultPromise.reject( $event )
      } catch (e) {}  
    },
    getByName(name) {
      const modal =  this.modals.find(v => v.modalAttrs.name === name )
      return modal
    },
    remove(id) {
      const index = this.modals.findIndex(v => v.id === id)

      if (index !== -1) {
        this.modals.splice(index, 1)
      }
    }
  }
}
</script>
